import React from "react";

/**
 *
 */
type Options = {
    key : string
    value : string
    display : string
    disabled : boolean
}

/**
 *
 */
type Data = {
    id : string
    name : string
    defaultValue : string
    options : Options[]
}

/**
 *
 * @param id
 * @param name
 * @param defaultValue
 * @param options
 * @constructor
 */
export default function Select({ id, name, defaultValue, options } : Data) {
    // render
    return (
        <select className={'form-select'} id={id} name={name} defaultValue={defaultValue}>
            {options.map((option) =>
                <option key={option.key} value={option.value} disabled={option.disabled}>{option.display}</option>
            )}
        </select>
    );
}